import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { MessageType } from "@/store/chats/types";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

interface Props {
  isMine: boolean;
  messageType?: MessageType;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'DeletedMessage',
  props: {
    isMine: { type: Boolean },
    messageType: {}
  },
  setup(__props: any) {

const props = __props;
const { t } = useI18n();

const text = computed(() => {
  if (props.messageType === MessageType.Audio) {
    return t("chat.chatContainer.messages.deleting.deletedAudioMessage");
  }
  return t("chat.chatContainer.messages.deleting.deletedMessage");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["deleted-message-text", { isMine: _ctx.isMine }])
  }, _toDisplayString(text.value), 3))
}
}

})